import {log} from "@dp-instant/utils";
import {Action, lazyGet} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {GiftPopupProps} from "@game/ui/popups/GiftPopup";
import {SkinManager} from "@game/coregame/managers/SkinManager";
import {UIEvents} from "@dp-instant/ui";
import {PopupType} from "@game/ui/PopupType";

@injectable()
export class ShowGiftPopupAction extends Action {
    @inject(TypesGame.model)
    private model: GameModel;

    async execute(): Promise<any> {
        const giftWasCollected = await new Promise<boolean>(onContinue => {
            const props: GiftPopupProps = {
                captured: this.model.currentContinent.stageLevel,
                total: this.model.currentContinent.totalStages,
                reward: lazyGet<SkinManager>(TypesGame.skinManager)?.getGift(),
                onContinue
            };
            this.dispatch(UIEvents.POPUP, {id: PopupType.GIFT, props});
        });
        log.debug("giftWasCollected", giftWasCollected);
    }
}
